'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type Dispatch, type PropsWithChildren, useContext, useReducer } from 'react';
import { type getInitialUserFromCookie } from '../helpers/parseJwt';
import { buildInitialUserState, initialUserState, type UserState } from './context';
import { userReducer } from './reducers/userReducer';
type UserContextType = {
  state: UserState;
  dispatch: Dispatch<any>;
};
const UserContext = createContext<UserContextType>({
  state: initialUserState,
  dispatch: () => {}
});
export const useUserState = () => {
  return useContext(UserContext);
};
type Props = PropsWithChildren<{
  // Server-injected initial payload (parsed from the ft-client cookie via
  // next/headers). When provided, the first render uses this instead of the
  // module-level `initialUserState` so SSR and client agree.
  initialUser?: ReturnType<typeof getInitialUserFromCookie>;
}>;
export const UserContextProvider = t0 => {
  const $ = _c(7);
  const {
    children,
    initialUser
  } = t0;
  let t1;
  if ($[0] !== initialUser) {
    t1 = initialUser !== undefined ? buildInitialUserState(initialUser) : initialUserState;
    $[0] = initialUser;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const initial = t1;
  const [state, dispatch] = useReducer(userReducer, initial);
  let t2;
  if ($[2] !== state) {
    t2 = {
      state,
      dispatch
    };
    $[2] = state;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <UserContext.Provider value={t2}>{children}</UserContext.Provider>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};